import { render, staticRenderFns } from "./TicketBoardCardTemplate.vue?vue&type=template&id=0c251d1c&scoped=true"
import script from "./TicketBoardCardTemplate.vue?vue&type=script&lang=js"
export * from "./TicketBoardCardTemplate.vue?vue&type=script&lang=js"
import style0 from "./TicketBoardCardTemplate.vue?vue&type=style&index=0&id=0c251d1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c251d1c",
  null
  
)

export default component.exports